// Partner/component/card/index.tsx
import React from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'

interface CardProps {
  href: string
  src: string
  alt: string
  width: number
  height: number
  name: string
  description: string
}

export const Card: React.FC<CardProps> = ({
  href,
  src,
  alt,
  width,
  height,
  name,
  description,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.logoContainer}>
        <a href={href} target='_blank' rel='noreferrer nofollow noopener'>
          <Image src={src} alt={alt} width={width} height={height} />
        </a>
      </div>
      <div className={styles.cardText}>
        <h3 className={styles.cardName}>{name}</h3>
        <p className={styles.cardDescription}>{description}</p>
      </div>
    </div>
  )
}
